<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card) pt-(--space-2)">
  <div class="mb-(--space-4) flex justify-between items-center">
    <div class="text-h1">{{ title() }}</div>
  </div>

  <div class="mt-(--space-8)">
    @if (ready() && assetId(); as parentId) {
      <app-auscultation-information-form
        mode="create"
        [parentId]="parentId"
        (formSubmit)="onFormSubmit($event)"
        (formCancel)="onFormCancel()" />
    }
  </div>
</div>
